export default {"src":"/_next/static/media/step3g.510b6f51.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};